import axios from "axios";
import {baseURL} from "../config/api";

export const getAllowDenyStatus = () => {
    return axios({
        url: baseURL + "allow_deny_statuses/",
        method: "GET"
    }).then(response => response.data);
};
